import { useCallback } from 'react';
import { useGetList, } from 'react-admin';
import { useSubscribeToRecordList } from './useSubscribeToRecordList';
/**
 * Alternative to useGetList() that subscribes to live updates on the record list
 *
 * @example
 * import { useGetListLive } from '@react-admin/ra-realtime';
 *
 * const LatestNews = () => {
 *     const { data, total, isLoading, error } = useGetListLive(
 *         'posts',
 *         { pagination: { page: 1, perPage: 10 }, sort: { field: 'published_at', order: 'DESC' } }
 *     );
 *     if (isLoading) { return <Loading />; }
 *     if (error) { return <p>ERROR</p>; }
 *
 *     return (
 *         <ul>
 *             {data.map(item =>
 *                 <li key={item.id}>{item.title}</li>
 *             )}
 *         </ul>
 *     );
 * };
 */
export var useGetListLive = function (resource, params, options) {
    if (params === void 0) { params = {}; }
    var res = useGetList(resource, params, options);
    var refetch = res.refetch;
    var callback = useCallback(function () {
        refetch({ cancelRefetch: true });
    }, [refetch]);
    useSubscribeToRecordList(callback, resource);
    return res;
};
